import React, { useState } from 'react'
import { Button, DialogOverlay, DialogOverlayActions, colors } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { NoticeWarning } from '@fs/zion-icon'
import FieldSelector from './FieldChipSelector'

/**
 * Displays an overlay with chips to select (can have multiple sets of chips).
 * @param {Object} overlay
 * @param {String} title
 * @param {Object} chipData
 * @param {Function} handleSelection
 * @param {Function} handleSelectionChange handle selection of fields before saving
 * @param {Object} fieldData
 * @param {Boolean} allowSelectingMultiple
 * @param {Boolean} requireAtLeastOneField Show error message if no fields are selected
 */
export default function FieldSelectorOverlay({
  overlay,
  title,
  chipData,
  handleSelection,
  handleSelectionChange = () => {},
  fieldData,
  allowSelectingMultiple = true,
  lockSharedFields = true,
  disabledFunc,
  unlinkingStates,
  showSearch = true,
}) {
  // Translation
  const [t] = useTranslation()
  const [currentChips, setCurrentChips] = useState(() => [])
  const [currentLockedChips, setCurrentLockedChips] = useState(() => [])
  const saveChangesHandler = () => {
    handleSelection(currentChips, currentLockedChips)
    overlay.close()
  }
  const { disabled, message } = disabledFunc ? disabledFunc(currentChips.concat(currentLockedChips), t) : {}

  return (
    <DialogOverlay
      {...overlay}
      title={title}
      footer={
        <DialogOverlayActions>
          <Button data-testid="field-selector-cancel-save-fields" onClick={() => overlay.close()}>
            {t('common-ui:cancel.action', 'Cancel')}
          </Button>
          <Button
            data-testid="field-selector-save-fields"
            onClick={saveChangesHandler}
            emphasis="high"
            disabled={disabled}
          >
            {t('field-selector-overlay.save.button', 'Save Fields')}
          </Button>
        </DialogOverlayActions>
      }
    >
      <FieldSelector
        allowSelectingMultiple={allowSelectingMultiple}
        handleSelection={(chips, lockedChips) => {
          setCurrentChips(chips)
          setCurrentLockedChips(lockedChips)
          handleSelectionChange(chips, lockedChips)
        }}
        chipData={chipData}
        fieldData={fieldData}
        lockSharedFields={lockSharedFields}
        unlinkingStates={unlinkingStates}
        showSearch={showSearch}
      />
      {disabled && (
        <p>
          <NoticeWarning color={colors.yellow10} />
          {message}
        </p>
      )}
    </DialogOverlay>
  )
}
